export default {"src":"/_next/static/media/icon-social-youtube-white.fde9d8af.svg","height":23,"width":33,"blurWidth":0,"blurHeight":0};